import { Avatar } from '@/components/Avatar'
import { Flex } from '@/components/Flex'
import { Typography } from '@/components/Typography'
import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { DashboardExperiments } from '@/experiments'
import { useIsMobile } from '@/hooks/useIsMobile'
import { PATHS } from '@/routes/PATHS'
import { LogoutOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons'
import { useFlag } from '@unleash/proxy-client-react'
import { Dropdown } from 'antd'
import { ChevronDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import styles from './styles.module.scss'

export const UserProfileDropdown = () => {
  const { t } = useTranslation()
  const { logout, userAttributes } = useCognitoAuth()
  const showBillingAndPaymentsPage = useFlag(DashboardExperiments.billingAndPaymentsPage)

  const isMobile = useIsMobile()

  if (!userAttributes) {
    return null
  }

  const userName = `${userAttributes.given_name} ${userAttributes.family_name}`
  const userInitial = userAttributes.given_name?.charAt(0) || ''

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'userProfile',
            icon: <UserOutlined />,
            label: <Link to={PATHS.userProfilePage}>{t('components.navbar.userProfile')}</Link>,
          },
          ...(showBillingAndPaymentsPage
            ? [
                {
                  key: 'billingAndPayments',
                  icon: <WalletOutlined />,
                  label: (
                    <Link to={PATHS.billingAndPaymentsPage}>
                      {t('components.navbar.billingAndPayments')}
                    </Link>
                  ),
                },
              ]
            : []),
          {
            key: 'logout',
            label: t('components.navbar.logout'),
            icon: <LogoutOutlined />,
            onClick: logout,
            danger: true,
          },
        ],
      }}
      trigger={['click']}
      placement="bottomRight"
      className={styles.userProfile}
    >
      <Flex align="center" gap={8}>
        <Avatar size={30}>{userInitial}</Avatar>
        <Typography.Text hidden={isMobile}>{userName}</Typography.Text>
        <ChevronDownIcon size={16} aria-label="user profile dropdown icon" />
      </Flex>
    </Dropdown>
  )
}
